import config from '../../config'
import fetch, { getFreshToken } from '../../lib/wrappedFetch'
import authService from '../../services/authService'

class AuthController {
  setToken = token => {
    config.setConfig({ authToken: token })
    return Promise.resolve()
  }
  setCredentials = params => {
    const { refreshToken, token, id } = params || {}
    config.setConfig({
      authToken: token,
      refreshToken,
      userId: id
    })
    return Promise.resolve()
  }
  login = ({ email, username, password }) => {
    return authService
      .login({ email, username, password })
      .then(res => {
        const { token, refreshToken, id } = res
        config.setConfig({
          authToken: token,
          refreshToken,
          userId: id
        })
        return res
      })
  }
  logout = ({ skipApi } = {}) => {
    return (
      skipApi
      ? Promise.resolve()
      : authService.logout()
    )
      .then(() => {
        config.setConfig({
          authToken: undefined,
          refreshToken: undefined,
          userId: undefined
        })
        return {
          success: true
        }
      })
  }
  getFreshToken = getFreshToken
  resetPassword = authService.resetPassword
  changePassword = authService.changePassword
  changePasswordByUserId = authService.changePasswordByUserId
  fetchImageUploadUrl = authService.fetchImageUploadUrl  
  fetchPaypalCredentials = authService.fetchPaypalCredentials
  setAuthContext = params => {
    return authService.setAuthContext(params)
      .then(res => {
        config.setConfig({ authToken: res.token })
        return res
      })
  }
  getAuthContext = params => {
    return authService.getAuthContext(params)
      .then(res => {
        return this.setCredentials(res)
        .then(() => {
          return res
        })
      })
  }
  changeInvalidPassword = authService.changeInvalidPassword
}

export default new AuthController()
 


// WEBPACK FOOTER //
// ../src/controllers/authController/authController.js